import React, { useContext, useEffect, useState } from "react";
import "./Admission.css";
import { getAcademicYears, getStudentDetailsByAdmission, resetGetStudentDetailsByAdmissionDetailsState } from "../../redux/features/student/studentSlice"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import Header from "../header/Header";
import logo from '../../assets/images/svbk_logo.png'
import AppContext from "../../storage/AppContext";
import useToast from "../../shared/Toast";
import * as constants from "../../config/config"

const Admission = () => {
  const [admissionNumber, setAdmission] = useState("")
  const [academicYear, setAcademicYear] = useState('')
  const [multipleClicks, setMultipleClicks] = useState(false)
  const appContext = useContext(AppContext)

  const dispatch = useDispatch()

  const studentDetails = useSelector(state => state?.student?.getStudentDetailsByAdmissionDetails?.data)
  const studentDetailsState = useSelector(state => state?.student?.getStudentDetailsByAdmissionDetails)
  const academicData = useSelector((state) => state.student.academicDetails);

  const navigate = useNavigate();
  const showToast = useToast();
  
  function getPreviousAcademicYear(currentYear) {
    if(!currentYear) return ""
    const [start, end] = currentYear?.split('-')?.map(Number);
    const prevStart = start - 1;
    const prevEnd = end - 1;
    return `${prevStart}-${prevEnd}`;
  }

  const currentYear = academicData?.data?.find((e) => e?.isCurrentYear)?.academicYear
  const academicYears = [currentYear, getPreviousAcademicYear(currentYear)]
  
  const isSearchButtonDisabled = multipleClicks || !admissionNumber || !academicYear


  useEffect(() => {
    if(studentDetailsState.status === "failed"){
        // setAdmission("")
        // setAcademicYear("")
        showToast({message: studentDetailsState?.error, type: 'error'})
        setMultipleClicks(true)
        const intervalId = setInterval(() => {
          clearInterval(intervalId)
          setMultipleClicks(false)
        },3000)
    }
}, [studentDetailsState])

  const handleSubmit = () => {
    const admission = admissionNumber.trim()
    dispatch(getStudentDetailsByAdmission({ admission, academicYear }))
  }

  const onClickView = (details, d) => {
    if (details.paymentStatus === "Unpaid") {
      navigate('/checkout', { state: {...details, academicYear} });
    } else {
      navigate('/offlinePaymentStatus', { state:  {...details, academicYear} })
    }
  }

  const onChange = (event) => {
    setAdmission(event.target.value)
  }

  const onPressEnter = (event) => {
    if (event.key === "Enter") {
      handleSubmit()
    }
  }

  useEffect(() => {
    dispatch(resetGetStudentDetailsByAdmissionDetailsState())
    dispatch(getAcademicYears());
  },[])

  const userDetails = appContext?.userDetails

  console.log("studentDetails",studentDetails)

  return (
    <>
    {userDetails?.active && <Header />}
      <div className="container1 p-2">
        <div className="body">
          <h5 className="admission-heading">Online Fees Collection Portal Academic Year 24 - 25</h5>
          {/* <p>Online Fees Collection Portal Academic Year 23 - 24 </p> */}

          <div className="textFieldContainer mt-3">
              <input
                value={admissionNumber}
                className="textInput"
                type="text"
                placeholder="Enter Admission Number"
                onChange={onChange}
                // onKeyDown={onPressEnter}
              />
              <select
                value={academicYear}
                className="selectInput"
                placeholder="Select Acedemic Year"
                onChange={(e) => setAcademicYear(e.target.value)}
              >
                <option value="" disabled selected>Select Academic Year</option>
                {academicYears.map((each) => <option value={each}>{each}</option>)}
              </select>
              <button className={isSearchButtonDisabled ? 'disabledButton' : 'submitButton'} disabled={isSearchButtonDisabled} style={{backgroundColor: multipleClicks && "#dddddd"}} onClick={handleSubmit}>{studentDetailsState.status === "loading" ? "Searching..." : "Search"}</button>
          </div>

          {studentDetailsState.status === "succeeded" &&
            (Object.keys(studentDetails).length !== 0) &&
            <>
            <div style={{overflow:"auto"}} className="mb-3 web-view mt-2">
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    {/* <th>Email</th> */}
                    {/* <th>Phone</th> */}
                    <th>Class</th>
                    <th>Section</th>
                    <th>Admission</th>
                    <th>Term</th>
                    <th>Amount</th>
                    {studentDetails?.termFee?.filter((eachTerm) => {
                        const discountAmount = eachTerm[Object.keys(eachTerm)[0]]?.discountedAmount;
                        return discountAmount && discountAmount !== "Pending" && discountAmount !== "Rejected" && discountAmount !== "NA" && eachTerm
                        }).length !== 0 && <th>Discounted Amount</th>}
                    <th>Status</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {studentDetails.termFee.map((eachTerm, i) => {
                    const discountAmount = eachTerm[Object.keys(eachTerm)[0]].discountedAmount
                    const details = {
                      name: studentDetails.name,
                      // email: studentDetails.email,
                      // phoneNumber: studentDetails.phoneNumber,
                      class: studentDetails.class,
                      section: studentDetails.section,
                      admissionNumber: studentDetails.admissionNumber,
                      term: Object.keys(eachTerm)[0],
                      amount: eachTerm[Object.keys(eachTerm)[0]].amount,
                      discountedAmount: discountAmount ? discountAmount === "Rejected" ? "NA" : discountAmount :"NA" ,
                      paymentStatus: eachTerm[Object.keys(eachTerm)[0]].paymentStatus
                    }

                    const { rollNo, section } = studentDetails

                    return (
                      <tr key={i}>
                        {Object.values(details).map(field =>
                          
                          ((field!=="Pending" && field!=="NA") || studentDetails?.termFee?.filter((eachTerm) => {
                            const discountAmount = eachTerm[Object.keys(eachTerm)[0]]?.discountedAmount;
                            return discountAmount && discountAmount !== "Pending" && discountAmount !== "Rejected" && discountAmount !== "NA" && eachTerm
                            }).length !== 0) && <td>{field}</td>
                        )}
                        <td style={{color:"blue",cursor:"pointer"}} onClick={() => { onClickView({ ...details, rollNo, section, class: studentDetails.class })}}>
                            {details.paymentStatus === "Paid" ? "View" : "Pay"}
                        </td>
                      </tr>
                    )
                  })}

                </tbody>
              </table>
            </div>

            <div className="mobile-view">
              <h5 className="mt-3">Basic Details :</h5>
              <div className="basic-details-card p-2">
                  <div className="basic-details-field-container">
                    <p className="basic-details-field-key">Name :</p>
                    <p className="basic-details-field-value">{studentDetails.name}</p>
                  </div>
                  {/* <div className="basic-details-field-container">
                    <p className="basic-details-field-key">Email :</p>
                    <p className="basic-details-field-value">{studentDetails.email}</p>
                  </div>
                  <div className="basic-details-field-container">
                    <p className="basic-details-field-key">Phone :</p>
                    <p className="basic-details-field-value">{studentDetails.phoneNumber}</p>
                  </div> */}
                  <div className="basic-details-field-container">
                    <p className="basic-details-field-key">Class :</p>
                    <p className="basic-details-field-value">{studentDetails.class}</p>
                  </div>
                  <div className="basic-details-field-container">
                    <p className="basic-details-field-key">Section :</p>
                    <p className="basic-details-field-value">{studentDetails.section}</p>
                  </div>
                  <div className="basic-details-field-container">
                    <p className="basic-details-field-key">Admission :</p>
                    <p className="basic-details-field-value">{studentDetails.admissionNumber}</p>
                  </div>
              </div>
              
              <h5 className="mt-3">Term Details :</h5>
                  {studentDetails.termFee.map((eachTerm, i) => {
                    const details = {
                      name: studentDetails.name,
                      email: studentDetails.email,
                      phoneNumber: studentDetails.phoneNumber,
                      admissionNumber: studentDetails.admissionNumber,
                      term: Object.keys(eachTerm)[0],
                      amount: eachTerm[Object.keys(eachTerm)[0]].amount,
                      discountedAmount: eachTerm[Object.keys(eachTerm)[0]].discountedAmount? (eachTerm[Object.keys(eachTerm)[0]].discountedAmount === "Rejected" ? "NA" : eachTerm[Object.keys(eachTerm)[0]].discountedAmount) :"NA" ,
                      paymentStatus: eachTerm[Object.keys(eachTerm)[0]].paymentStatus
                    }
                    const { rollNo, section } = studentDetails

                    return(
                      <div className="term-details-card mb-3 p-2">
                          <div className="term-details-field-container">
                            <p className="term-details-field-key">Term :</p>
                            <p className="term-details-field-value">{details.term}</p>
                          </div>
                          <div className="term-details-field-container">
                            <p className="term-details-field-key">Amount :</p>
                            <p className="term-details-field-value">{details.amount}</p>
                          </div>
                          {studentDetails?.termFee?.filter((eachTerm) => {
                            const discountAmount = eachTerm[Object.keys(eachTerm)[0]]?.discountedAmount;
                            return discountAmount && discountAmount !== "Pending" && discountAmount !== "Rejected" && discountAmount !== "NA" && eachTerm
                            }).length !== 0 && 
                            <div className="term-details-field-container">
                              <p className="term-details-field-key">Discounted Amount :</p>
                              <p className="term-details-field-value">{details.discountedAmount}</p>   
                          </div>}
                          <div className="term-details-field-container">
                            <p className="term-details-field-key">Status :</p>
                            <p className="term-details-field-value">{details.paymentStatus}</p>
                          </div>
                          <div className="d-flex justify-content-end">
                            <button className="btn btn-primary" onClick={() => {onClickView({ ...details, rollNo, section, class: studentDetails.class })}}>{details.paymentStatus === "Paid" ? "View" : "Pay"}</button>
                          </div>
                      </div>
                    )
              })
            }
            </div>
            </>
            
            
          }

          <hr className="hrow" />

          <div className="info-container">
            <h5 className="info-heading mb-2">Get In Touch</h5>
            <div>
              <div className="info-field-container">
                <p className="info-field-key">Phone Number</p>
                <p className="info-field-value">{constants.phoneNumber}</p>
              </div>
              <div className="info-field-container">
                <p className="info-field-key">Email</p>
                <p className="info-field-value">{constants.email}</p>
              </div>
              <div className="info-field-container">
                <p className="info-field-key">Address</p>
                <p className="info-field-value">{constants.address}</p>
              </div>
            </div>

          </div>

        </div>
        <div className="footer">Razorpay Platform App</div>
      </div>
    </>
  );
};
export default Admission;
